module.exports = __webpack_public_path__ + "img/TM-MoonBaboon.fc7af1c9.png";